import React from 'react';
import { TableRow, TableCell, Pagination as CarbonPagination } from 'carbon-components-react';
import { Checkmark24 } from '@carbon/icons-react';
import SanitizedHTML from 'react-sanitized-html';
import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import isEqual from 'lodash.isequal';
import moment from 'moment';
import { StatusTag } from '../../helpers/PageBreadCrumb';
import { CompletionStatusTag } from '../../components/functions/CompletionStatusTag';

export function RenderDataTableCell(props) {
    // const isBool = (item) => { //controlla il contenuto di cell.value
    //     return typeof item === 'boolean' ||
    //         (typeof item === 'object' && item !== null && typeof item.valueOf() === 'boolean');
    // }

    const { cell, className, header, isExt } = props;

    const isBool = () => (header != null && header.type === "bool") || false;

    //if separato per la colonna inUse perchè ha uno style diverso
    if (cell.info.header === 'inUse') {
        return (
            <TableCell
                key={cell.id}
                id={cell.id}
                className={"tableActions align-center " + className}>
                {
                    cell.value && <Checkmark24 fill="#1A3E4C" aria-label="In Use" />
                }
            </TableCell>
        );
    }

    //colonne html, type == html
    if (header != null && header.type === "html") {
        return (
            <TableCell key={cell.id} >
                <SanitizedHTML
                    allowedTags={false}
                    allowedAttributes={false}
                    html={cell.value} className="html-field" />
            </TableCell>
        );

    }
    //Date
    if (header != null && header.type === "date") {
        return (
            <TableCell key={cell.id} className={className}>
                {
                    switchDateFormat(cell.value, 'date')
                }
            </TableCell>
        );

    }
    //Date
    if (header != null && header.type === "datetime") {
        return (
           <TableCell key={cell.id} className={className}>
                {
                   
                    switchDateFormat( moment.utc(cell.value, 'YYYY-MM-DD  HH:mm').local().format('YYYY-MMM-DD h:mm A') , 'datetime')
                   
                }
            </TableCell>
        );

    }
    //Status
    if (header != null && header.type === "status") {
        return (
            <TableCell key={cell.id} className={className}>
                {/* RITM0623664 */}
                {<StatusTag value={(isExt && header.header.includes("Plan")) ? "Ext-" + cell.value : cell.value} />}
                {/* FINE  RITM0623664 */}

            </TableCell>
        );

    }

    // HSE Review Status
    if (header != null && header.type === "completionStatus") {
        return (
            <TableCell key={cell.id} className={className}>
                <CompletionStatusTag value={cell.value} />
            </TableCell>
        );
    }



    // RITM1133680
    if(props.maskedValue != undefined && props.maskedValue)
    {
        if (cell.info.header === "fullName") {
            return (
                <TableCell key={cell.id} className={className}>
                   { cell.value != null ? "xxxxxxxxxxxxxxx" : cell.value}
                </TableCell>
            );
        }

        if (cell.info.header === "email") {
            return (
                <TableCell key={cell.id} className={className}>
                   { cell.value != null && cell.value !='xxxx@xxx.xxxx' ? "xxxx@xxx.xxxx" : cell.value}
                </TableCell>
            );
        }
    }

    // HCA Level RITM1216061
    if (cell.info.header === "hcAlevel") {
        return (
            <TableCell key={cell.id} className={className}>
                {cell.value == "6" ? "NA" : cell.value}
            </TableCell>
        );
    }
    

    //default
    return (
        <TableCell key={cell.id} className={className + (isBool(cell.value) ? " align-center" : "")}>
            {
                isBool(cell.value) ?
                    (cell.value && <Checkmark24 fill="#1A3E4C" aria-label="" />)
                    :
                    cell.value
            }
        </TableCell>
    );

}

export function NoRecordsPlaceholder(props) {
    return (
        <TableRow>
            <TableCell colSpan={props.colSpan} className="no-records-table">
                <div  title={props.title}>
                    <p>{props.labelText || "No Result Found"}</p>
                </div>
            </TableCell>
        </TableRow>
    );
}

export class Pagination extends React.Component {

    shouldComponentUpdate(nextProps, nextState) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        return (
            <CarbonPagination
                {
                ...this.props
                }
            />
        );
    }
}
